import type React from 'react';

import { MainLayout, type MainLayoutProps } from './MainLayout';

/**
 * Layout registry for the nova fixed routes. Every route renders in
 * `main` unless its entry in `router.tsx` names another key — add new layouts
 * here and they become assignable per route.
 */
export type LayoutComponent = React.ComponentType<MainLayoutProps>;

export const LAYOUTS = {
  main: MainLayout,
} as const satisfies Record<string, LayoutComponent>;

export type LayoutKey = keyof typeof LAYOUTS;

export const DEFAULT_LAYOUT: LayoutKey = 'main';

export { MainLayout };
